import createReactComponent from '../createReactComponent';
export default createReactComponent('plus', 'Plus', [["path",{"d":"M18 12h-6m0 0H6m6 0V6m0 6v6","key":"svg-0"}]]);